import { proxy } from 'valtio/vanilla';
const state = proxy({
    ready: false,
    pending: false
});
export const WalletButtonController = {
    state,
    setReady(ready) {
        state.ready = ready;
    },
    setPending(pending) {
        state.pending = pending;
    },
    setError(error) {
        state.error = error;
    },
    setData(data) {
        state.data = data;
    }
};
//# sourceMappingURL=WalletButtonController.js.map